module.exports = __webpack_public_path__ + "img/song_cover.73aa98b2.jpg";